// extracted by mini-css-extract-plugin
export default {"item":"Item_item__EqF+M","name":"Item_name__gzus0"};